import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { server } from "../server";

const UserIdentityRedirectPage = () => {
  const { uniqueId } = useParams();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let cancelled = false;

    const redirectToProfile = async () => {
      if (!uniqueId) {
        setErrorMessage("Missing profile ID.");
        return;
      }

      try {
        const response = await axios.get(
          `${server}/user/user-info/unique/${encodeURIComponent(uniqueId)}`
        );
        const handle = response.data?.user?.handle;

        if (!handle) {
          throw new Error("Profile not found.");
        }

        if (!cancelled) {
          navigate(`/user/${handle}`, { replace: true });
        }
      } catch (error) {
        if (!cancelled) {
          setErrorMessage(error.response?.data?.message || error.message || "Profile not found.");
        }
      }
    };

    redirectToProfile();

    return () => {
      cancelled = true;
    };
  }, [uniqueId, navigate]);

  if (!errorMessage) {
    return (
      <div className="activation-page">
        <p>Opening profile...</p>
      </div>
    );
  }

  return (
    <div className="activation-page">
      <p>{errorMessage}</p>
      <Link to="/">Return Home</Link>
    </div>
  );
};

export default UserIdentityRedirectPage;